<template>
  <div v-show="show">
    <div class="mt-2 d-flex search-box chat-search-box">
      <!--b-button-group class="mr-3">
        <b-button
          class="py-0 px-1"
          variant="white"
        >
          <i
            class="ri-arrow-up-s-line"
            style="font-size: 30px;"
          />
        </b-button>
        <b-button
          class="py-0 px-1"
          variant="white"
        >
          <i
            class="ri-arrow-down-s-line"
            style="font-size: 30px;"
          />
        </b-button>
      </b-button-group-->

      <div class="flex-fill input-group bg-light input-group-lg rounded-lg">
        <div class="input-group-prepend">
          <button
            class="btn btn-link text-muted pr-1 text-decoration-none"
            type="button"
          >
            <i class="ri-search-line search-icon font-size-18" />
          </button>
        </div>
        <input
          ref="search"
          v-model="query"
          type="search"
          class="form-control bg-light"
          :placeholder="$t('room.header.search.placeholder')"
        >
      </div>

      <b-button
        class="ml-2 py-0"
        variant="white"
        @click="show = false"
      >
        <i class="ri-close-circle-line font-size-24" />
      </b-button>
    </div>

    <search-list :room-id="roomId" />
  </div>
</template>

<script>
import SearchList from "@/components/Room/Header/Search/ListSearchHeaderRoomComponents";

export default {
  components: {
    SearchList,
  },
  props: {
    roomId: {
      type: String,
      default: '',
    },
  },
  computed: {
    show: {
      get() {
        return this.$store.state.roomSearch.show;
      },
      set(is) {
        return this.$store.commit('roomSearch/SET_SHOW', is);
      },
    },
    query: {
      get() {
        return this.$store.state.roomSearch.query;
      },
      set(query) {
        return this.$store.commit('roomSearch/SET_FILTER_QUERY', query);
      },
    },
  },
  watch: {
    roomId() {
      this.show = false
    },
    show(show) {
      show && this.$nextTick(() => this.$refs.search.focus());
    },
  },
}
</script>

<style scoped>

</style>
